module.exports = __webpack_public_path__ + "static/media/vilnius-17.32ffa195.jpg";